type Props = {
  icon: React.ReactNode;
  title: string;
  description: string;
};
export const EsimInfoCardItem = ({icon, title, description}: Props) => {
  return (
    <li className="flex gap-4 items-start">
      <div className="shrink-0 rounded-full p-1.5 bg-[color-mix(in_srgb,var(--primary)_10%,transparent)]">{icon}</div>
      <div className="flex flex-col gap-1">
        <span className="font-semibold leading-6">{title}</span>
        <span className="text-sm font-normal leading-6">{description}</span>
      </div>
    </li>
  );
};
